/* @flow */

import React from 'react';
import Immutable from 'immutable';
import * as UserApi from 'user/api';
import DiffusionHeader from './DiffusionHeader';
import DiffusionTargets from './DiffusionTargets';

type Props = {
  targets: Array<Target>,
  isEditable: boolean,
  onUpdate: (targets: Array<Target>) => void,
  attached?: boolean,
};

type State = {
  isFetching: boolean,
  roles: Array<UserRole>,
};

class DiffusionList extends React.Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isFetching: false,
      roles: [],
    };
  }

  componentDidMount() {
    this.setState({ isFetching: true });

    // Fetching roles
    UserApi.fetchRoles().then(roles =>
      this.setState({
        isFetching: false,
        roles,
      })
    );
  }

  onAddTarget = (target: Target) => {
    const { targets, onUpdate } = this.props;
    onUpdate([...targets, target]);
  };

  onDeleteTarget = target => {
    const { targets, onUpdate } = this.props;
    onUpdate(Immutable.Set(targets).remove(target).toArray());
  };

  onClearTargets = () => this.props.onUpdate([]);

  render() {
    const { targets, isEditable, attached } = this.props;
    const { isFetching, roles } = this.state;

    return (
      <div>
        <DiffusionHeader
          isFetching={isFetching}
          isEditable={isEditable}
          roles={roles}
          attached={attached}
          onAdd={this.onAddTarget}
          onClear={this.onClearTargets}
        />
        <DiffusionTargets
          isFetching={isFetching}
          isEditable={isEditable}
          targets={targets}
          roles={roles}
          attached={attached}
          onDelete={this.onDeleteTarget}
        />
      </div>
    );
  }
}

export default DiffusionList;



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/DiffusionList.js